export const SENTRY_RELEASE: string | undefined = '91d2e6d75e5af4c2713e24c9226c89036fb6af21';
